import StyleSelect from "../../../components/Button/AutoComplete";
import StyleInput from "../../../components/Button/Input";
import tabletrans from "../../../translate/tables";
function ShemshSku(props) {
  const content = props.content;
  const def = content ? content.filter : "";

  return (
    <div className="pd-row">
      <div className="row-title">
        <h4>{tabletrans.propertie[props.lang]}</h4>
        <p>{tabletrans.attributes[props.lang]}</p>
      </div>
      <div className="row-box">
        <div className="probs-wrapper">
          <div className="input-wrapper">
            {/*<StyleInput title={tabletrans.productCode[props.lang]} direction={props.direction}
                 class={"formInput"} defaultValue={def?def.productCode:''} 
                 action={(e)=>props.setProductChange(prevState => ({
                    ...prevState,
                    productCode:e
                  }))}/>*/}
            <StyleInput
              title={tabletrans.productSku[props.lang]}
              direction={props.direction}
              class={"formInput"}
              defaultValue={def ? def.sku : ""}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  sku: e,
                }))
              }
              disabled={true}
            />
            <StyleInput
              title="گرم"
              direction={props.direction}
              class={"formInput"}
              defaultValue={def ? def.weight : ""}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  weight: e,
                }))
              }
              disabled={true}
            />
            <StyleInput
              title="عیار"
              direction={props.direction}
              class={"formInput"}
              defaultValue={def ? def.ayar : ""}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  ayar: e,
                }))
              }
              disabled={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default ShemshSku;
